// This file is generated by pnpm icons:generate. Do not edit.

import {ListSparkle_Stroke2_Corner0_Rounded as CanonicalListSparkle_Stroke2_Corner0_Rounded} from './List'

/** @deprecated Import ListSparkle_Stroke2_Corner0_Rounded from `#/components/icons/List` instead. */
export const ListSparkle_Stroke2_Corner0_Rounded =
  CanonicalListSparkle_Stroke2_Corner0_Rounded
